import { Outlet } from "react-router-dom";
import { DevChrome } from "@/components/dev/DevChrome";
import { RightCommandBar } from "@/components/command/RightCommandBar";
import { DockProvider } from "@/components/command/DockContext";

export function DevLayout() {
  return (
    <DockProvider>
      <div className="relative min-h-dvh overflow-x-hidden bg-[#0a0b14] text-white">
        <div aria-hidden className="pointer-events-none fixed inset-0 z-0">
          <div className="absolute inset-0 bg-[radial-gradient(80%_60%_at_50%_-10%,rgba(199,19,99,0.18),transparent_60%)]" />
          <div className="absolute inset-0 bg-[radial-gradient(60%_50%_at_100%_100%,rgba(52,211,153,0.10),transparent_55%)]" />
          <div className="absolute inset-0 bg-[radial-gradient(50%_50%_at_0%_60%,rgba(96,165,250,0.10),transparent_55%)]" />
        </div>

        <DevChrome />

        <main className="relative z-10">
          <Outlet />
        </main>

        <RightCommandBar area="dev" />
      </div>
    </DockProvider>
  );
}
